export const fontFamilyConfigModel = {
    options: [
        'Arial, Helvetica, sans-serif',
        '"Comic Sans MS", Helvetica, sans-serif',
        '"Courier New", Courier, monospace',
        'Georgia, serif',
        'Helvetica, Arial, sans-serif',
        '"Lucida Sans Unicode", "Lucida Grande", sans-serif',
        'Tahoma, Geneva, sans-serif',
        '"Times New Roman", Times, serif',
        '"Trebuchet MS", Helvetica, sans-serif',
        'Verdana, Geneva, sans-serif'
    ],
    supportAllValues: true
};
